import React from "react";
import NGLViewer from "./NGLViewer/NGLViewer";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import SunBurstChart from './Dashboard/SunburstChart';
import AppContext from './AppContext';
import ToggleButtonGroup
    from "@material-ui/lab/ToggleButtonGroup/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton/ToggleButton";
import {withStyles} from "@material-ui/core/styles";
import PropTypes from "prop-types";
import CssBaseline from '@material-ui/core/CssBaseline';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import RestraintsPanel from "./Dashboard/RestraintsPanel/RestraintsPanel";
import QualityPanel from "./Dashboard/QualityPanel/QualityPanel";
import RestraintReport from "./Dashboard/RestraintReport/RestraintReport";
import theme from './theme'
import CircularProgress from "@material-ui/core/CircularProgress";
import EnsemblePanel from "./Dashboard/EnsemblePanel";
import DownloadPanel from "./Dashboard/DownloadPanel/DownloadPanel";
import SunburstPanel from "./Dashboard/SunburstPanel/SunburstPanel";
import {get} from 'lodash'
// All react component that have a constructor function should start with
// super(props)
// React component can have a state by setting this.state in their constructor

// TODO: Gather all theme const within the main app file !!!!
// TODO: https://reacttraining.com/react-router/

const drawerWidth = 240;

const styles = theme => ({
    root: {
        display: 'flex',
        flexGrow: 1,
    },
    link: {
        outline: 'none !important',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerTitle: {
        marginLeft: 16,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        height: '100vh',
        overflow: 'auto',
    },
    chartContainer: {
        marginLeft: -22,
    },
    tableContainer: {
        height: 320,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center'
    },
    progress: {
        margin: theme.spacing(2),
    },
});


// Main component for attaching react app to <div id="app"> </div>
// TODO: use React.Fragment if there is more than one component
@withStyles(styles)
class App extends React.Component {

    // endpoint props is required in order to fetch data from REST API
    static propTypes = {
        endpoint: PropTypes.string.isRequired,
        appName: PropTypes.string,
    };

    state = {
        data: null,
        iteration_id: 0,
        dataContributions: null,
        loaded: false,
        loadingMessage: "Loading...",
    };

    componentDidMount() {
        fetch(this.props.endpoint)
            .then(response => {
                if (response.status !== 200) {
                    let message = "Something went wrong " + response.status;
                    return this.setState({loadingMessage: message});
                }
                return response.json();
            })
            .then(data => {
                // Sort data by iteration id
                data.iterations.sort((a, b) => {
                    return a.iteration_id - b.iteration_id
                });
                let last_it = data.iterations.findIndex((iter) => {
                    return iter.last_flag
                });
                last_it = last_it ? last_it : data.iterations.length - 1;
                let dataContrib = this.formatDataContributions(data, last_it);
                this.setState({
                    data: data,
                    dataContributions: dataContrib,
                    iteration_id: last_it,
                    loaded: true,
                });
                console.log("Data loaded from REST API");
            }).catch(error => {
            console.log("Error during the fetching of the data from REST API");
            console.log(error.stack);
            console.log(error);
        });
    };

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     this.formatDataContributions();
    // }

    formatDataContributions(data, iteration) {
        let formatContribution = (specs, contribRange, contribIdx, unambigFlag) => {
            let res = {"name": contribRange};
            for (let spec of specs) {
                let value = (unambigFlag) ? (spec.unambiguous.used) : (spec.ambiguous.contributions[contribIdx].value);
                Object.assign(res, {
                    [spec.name]: value
                })
            }
            return res
        };
        let specs = data.iterations[iteration].spectra;
        if (specs.length !== 0) {
            // Start with unambiguous values to the array
            let upData = [formatContribution(specs, "1", null, true)];
            upData = upData.concat(data.iterations[iteration].spectra[0].ambiguous.contributions.map(
                (contrib, contribIdx) => {
                    return formatContribution(specs, contrib.range, contribIdx, false);
                }));
            // this.setState({dataContributions:upData});
            return upData
        } else {
            return null
        }
    }

    render() {
        // {tier.buttonText}
        // TODO: DataContext useless
        const {classes, appName} = this.props;
        const {data, iteration_id, dataContributions} = this.state;

        return (
            <MuiThemeProvider theme={theme}>
                {data ?
                    <AppContext.Provider value={{
                        state: this.state,
                        appName: appName.charAt(0).toUpperCase() + appName.slice(1),
                        handleIteration: (event, iteration) => {
                            if (iteration !== null) {
                                let dataContrib = this.formatDataContributions(data, iteration);
                                this.setState({
                                    iteration_id: iteration,
                                    dataContributions: dataContrib,
                                })
                            }
                        },
                    }}>
                        <AppContext.Consumer>
                            {(context) => (
                                <React.Fragment>
                                    <CssBaseline/>
                                    <Grid container alignItems="stretch"
                                          spacing={4} className={classes.root}>

                                        <Grid container item
                                              alignItems='center'>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={4}
                                                md={4}
                                                lg={4}
                                                xl={4}
                                            >
                                                <Typography
                                                    variant="h2"
                                                    gutterBottom>
                                                    {context.appName} Report
                                                </Typography>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={8}
                                                md={8}
                                                lg={8}
                                                xl={8}
                                            >
                                                <Grid
                                                    container
                                                    justify='flex-end'
                                                >
                                                    <Grid item>
                                                        <ToggleButtonGroup
                                                            value={context.state.iteration_id}
                                                            exclusive
                                                            onChange={context.handleIteration}
                                                        >
                                                            {context.state.data.iterations.map((item, index) => (
                                                                <ToggleButton
                                                                    className={classes.link}
                                                                    key={item.iteration_id}
                                                                    value={index}>{item.name}</ToggleButton>
                                                            ))}
                                                        </ToggleButtonGroup>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <NGLViewer
                                                metadata={context.state.iteration_id.toString()}
                                                itername={get(context, `state.data.iterations.${context.state.iteration_id}.name`)}
                                                pdb={get(context, `state.data.iterations.${context.state.iteration_id}.fitted_pdb`)}/>
                                        </Grid>
                                        {get(context, `state.data.iterations.${context.state.iteration_id}.name`) === "REFINE" ?
                                            <Grid item xs={12}>
                                                <Typography>
                                                    For restraints statistics,
                                                    download the full run
                                                    archive {' '}
                                                    <a
                                                        target="_blank"
                                                        href={get(context, `state.data.tarfile`)}>
                                                        here
                                                    </a>
                                                </Typography>
                                            </Grid>
                                            :
                                            <React.Fragment>
                                                <Grid
                                                    item
                                                    xl={4}
                                                    lg={4}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <RestraintReport
                                                        type="used_restraints"
                                                        desc="USED RESTRAINTS"
                                                        iconType="barChart"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xl={4}
                                                    lg={4}
                                                    md={6}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <RestraintReport
                                                        type="violated_restraints"
                                                        desc="VIOLATED RESTRAINTS"
                                                        iconType="warning"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xl={4}
                                                    lg={4}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <RestraintReport
                                                        type="merged_restraints"
                                                        desc="MERGED RESTRAINTS"
                                                        iconType="merge"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xl={6}
                                                    lg={6}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <RestraintReport
                                                        type="filtered"
                                                        desc="FILTERED CROSS-PEAKS"
                                                        iconType="info"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xl={6}
                                                    lg={6}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                >
                                                    <RestraintReport
                                                        type="unassigned"
                                                        desc="UNASSIGNED CROSS-PEAKS"
                                                        iconType="info"
                                                    />
                                                </Grid>
                                            </React.Fragment>
                                        }

                                        {context.state.dataContributions &&
                                        <Grid
                                            item
                                            xl={6}
                                            lg={6}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                        >
                                            <RestraintsPanel
                                                dataContributions={context.state.dataContributions}
                                            />
                                        </Grid>
                                        }

                                        <Grid
                                            item
                                            xl={6}
                                            lg={6}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                        >
                                            <EnsemblePanel/>
                                        </Grid>
					 {get(context, `state.data.iterations.${context.state.iteration_id}.name`) != "REFINE" &&
                                        <Grid item xl={6} lg={6} md={12} sm={12}
                                              xs={12}>
                                            <SunburstPanel/>
                                        </Grid>
					}
                                        {get(context, `state.data.iterations.${context.state.iteration_id}.qual_report.length`) !== 0 &&
                                        <Grid
                                            item
                                            xl={6}
                                            lg={6}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                        >
                                            <QualityPanel/>
                                        </Grid>
                                        }

                                        <Grid
                                            item
                                            xl={6}
                                            lg={6}
                                            md={12}
                                            sm={12}
                                            xs={12}

                                        >
                                            <DownloadPanel/>

                                        </Grid>


                                    </Grid>
                                </React.Fragment>
                            )}
                        </AppContext.Consumer>
                    </AppContext.Provider> :
                    <Grid container justify="center">
                        <CircularProgress className={classes.progress}/>
                        <Typography variant="button" display="block"
                                    gutterBottom>
                            Loading
                        </Typography>
                    </Grid>
                }
            </MuiThemeProvider>
        );
    }
}


export default App;
